import e from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as o}from"../../../theme/index.js";const t=o["theme"],n=e.button`
  ${t.mixin.fontButtonS};
  position: relative;
  width:  ${e=>e.fullWidth?"100%":"fit-content"};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${t.colorVariables.bgYellow};
  color: ${t.colorVariables.textDark};

  font-family: ${t.mainFont};
  text-decoration: none;

  border: none;
  border-radius: ${t.borderRadiusVariables.main};
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  overflow: hidden;

  & > span {
    position: relative;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  &:not(:disabled):active {
    transition: all 0.1s ease-in-out;
  }

  :disabled {
    cursor: default;
  }
}`,i=e.span``,r=e.span``,s=e.span`
  margin: 0 4px;
`;n.defaultProps=o;export{s as ButtonText,r as EndIcon,i as StartIcon,n as StyledButtonBase};
